import { render, staticRenderFns } from "./assignment-submit.vue?vue&type=template&id=7af99eaf&scoped=true"
import script from "./assignment-submit.vue?vue&type=script&lang=js"
export * from "./assignment-submit.vue?vue&type=script&lang=js"
import style0 from "./assignment-submit.vue?vue&type=style&index=0&id=7af99eaf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af99eaf",
  null
  
)

export default component.exports